/** Emitted only by explicit local creation, never by hydration or launch. */
export const NOTIFICATION_NEED = "tally:notification-need";
export function notificationNeed(): void {
  if (typeof window !== "undefined") window.dispatchEvent(new Event(NOTIFICATION_NEED));
}
